export default {
  name: "TaiChiItem",
  components: {},
  props: {
    flag: {
      type: Number,
      default: null
    },
    rotate: {
      type: Number,
      default: 0
    },
    idx: {
      type: Number,
      default: 0
    },
    imgIdx: {
      type: Number,
      default: 1
    },
    choosed: {
      type: Number,
      default: 0
    },
    showIdx: {
      type: Boolean,
      default: false
    },
    showBox: {
      type: Boolean,
      default: false
    },
    answerMode: {
      type: Boolean,
      default: false
    },
    result: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chooseSide: 0
    };
  },
  methods: {
    onLeftClick() {
      if (this.chooseSide == 1) {
        this.chooseSide = 0;
        this.$emit('clearChoose', Math.abs(this.idx));
        return;
      }
      this.chooseSide = 1;
      this.$emit('choosed', Math.abs(this.idx));
    },
    onRightClick() {
      if (this.chooseSide == 2) {
        this.chooseSide = 0;
        this.$emit('clearChoose', Math.abs(this.idx) * -1);
        return;
      }
      this.chooseSide = 2;
      this.$emit('choosed', Math.abs(this.idx) * -1);
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};